import * as React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Button, ButtonGroup, Flex, Text } from '@chakra-ui/react';

const Paginate = ({ conn, contentName, maxRows }) => {
  const {
    loadNext,
    loadPrevious,
    requestState,
    total,
    pageNumber,
    batchSize,
    loading,
  } = conn;

  const start = (pageNumber - 1) * batchSize + 1;
  let end = Math.min(pageNumber * batchSize, total);
  if (maxRows > 0) {
    end = Math.min(start + maxRows - 1, total);
  }

  const showPagination =
    !conn.noDataAfterLoading && requestState !== 'reconfiguring' && !loading;
  return (
    showPagination && (
      <Flex align='center' justify='space-between'>
        {(total && (
          <Text color='gray' fontSize='sm'>
            {start}-{end} of {total} {contentName}
          </Text>
        )) ||
          null}
        <ButtonGroup variant='outline' size='sm'>
          {pageNumber - 1 > 0 && (
            <Button
              as='a'
              rel='prev'
              onClick={loadPrevious}
              border='1px solid blue'
              borderRadius='20px'
              minWidth='6em'
              color='blue'
              fontWeight='light'
              cursor='pointer'
            >
              Previous
            </Button>
          )}
          {total > pageNumber * batchSize && (
            <Button
              as='a'
              rel='next'
              onClick={loadNext}
              border='1px solid blue'
              borderRadius='20px'
              minWidth='6em'
              cursor='pointer'
              fontWeight='light'
              color='blue'
            >
              Next
            </Button>
          )}
        </ButtonGroup>
      </Flex>
    )
  );
};

Paginate.defaultProps = {
  maxRows: -1,
};

Paginate.propTypes = {
  conn: PropTypes.object,
  contentName: PropTypes.string,
  maxRows: PropTypes.number,
};

export default observer(Paginate);
